import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Img = styled.img`
    width: 112px;
    height: 112px;
`;

const ImgEmpty = (props) => {
    const { className } = props;
    return <Img className={className} src={require("_assets/images/cherry-list-is-empty.png").default} />
}

ImgEmpty.propTypes = {
    className: PropTypes.string,
};

ImgEmpty.defaultProps = {
    className: "",
}

export default ImgEmpty;